/**
 * SkinAnalysisWizard — public-facing skin analysis page.
 * Delegates entirely to the shared SkinQuiz component which handles
 * both guest and authenticated member flows with cross-tab session awareness.
 */
import { SkinQuiz } from '@/components/SkinQuiz';
import { SEO } from '@/components/SEO';

export function SkinAnalysisWizard() {
  return (
    <>
      <SEO
        title="Free AI Skin Analysis | Marple & Co Skin Assessment"
        description="Take Marple & Co's free AI-powered holistic skin assessment. Get personalised African botanical skincare recommendations based on your unique skin type, concerns, and lifestyle."
        path="/analysis"
        schema={{
          "@context": "https://schema.org",
          "@type": "WebApplication",
          "name": "Marple & Co Free Skin Analysis",
          "url": "https://marplecompany.co.za/skin-analysis",
          "description": "Free AI-powered holistic skin assessment with personalised product recommendations.",
          "applicationCategory": "HealthApplication",
          "offers": { "@type": "Offer", "price": "0", "priceCurrency": "ZAR" }
        }}
      />
      <SkinQuiz />
    </>
  );
}
